export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
    },
    brand: {
      50: "#cbbff8",
      100: "#876cea",
      200: "#1878C8",
      300: "#542de1",
      400: "#4a25d0",
      500: "#3915BC",
      600: "#FF0000",
      700: "#1c0377",
      // 700: "#000",
      800: "#130156",
      // 800: "#000",
      900: "#0e0042"
      // 900: "#000"
    },
  },
  styles: {
    global: (props) => ({
      body: {
        fontFamily: "Plus Jakarta Display",
      },
      "*::placeholder": {
        color: "gray.400",
      },
      html: {
        fontFamily: "Plus Jakarta Display",
      },
    }),
  },
};
